import { useMemo } from "react";
import ServiceTypeMapper from "../../mappers/ServiceTypeMapper";
import ServiceType from "../../models/domain/ServiceType";
import Path from "../../models/ui/Path";
import { ServiceTypeListResponse } from "../../models/serviceApi/ServiceTypeListResponse";
import useRemoteResource from "../remoteResource/useRemoteResource";

export default function useServiceTypes() {
  const path = useMemo(() => {
    return new Path(["api", "v1", "service-types"]).toString();
  }, []);

  const { resource, error, isLoading, refresh } =
    useRemoteResource<ServiceTypeListResponse>(path);

  const mappedTypes: ServiceType[] | undefined = useMemo(() => {
    if (!resource?.serviceTypes) return undefined;
    return ServiceTypeMapper.mapList(resource.serviceTypes);
  }, [resource]);

  return {
    serviceTypes: mappedTypes,
    isLoading,
    error,
    refresh,
  };
}
